<template>
    <TopContainer :showAssignmentScore="false">
        <div>
            <validation-observer ref="formObserver">
                <div id="register">
                    
                    <form id="RegisterForm" method="POST" class="register-form" v-on:submit.prevent="onLoginClick(form.register)">
                        <img src="./images/register/playandwin.png"/>
                        
                        <span style="padding-left: 2%; padding-bottom: 20px;">Om mee te doen aan de quiz moet je jezelf eerst registreren. Vul je emailadres en een wachtwoord in. Klik daarna op registreer.</span>
                        <span v-if="requestFailed" style="color: red; padding-left: 2%; padding-bottom: 25px;">Er is iets fouts gegaan, probeer het later nog eens.</span>

                        <validation-provider class="validation-provider" name="email" rules="email-required|email" v-slot="{ errors }">
                            <label id="EMailLabel" for="EMailTextBox" >E-MAILADRES</label>
                            <input id="email" name="email" tabindex="1" type="text" v-model="form['register'].email" />
                            <span class="validation-error">{{ errors[0] }}</span>
                        </validation-provider>
                        
                        <validation-provider class="validation-provider" name="password" rules="pass-required|pass-min-6" v-slot="{ errors }">
                            <label id="PasswordLabel" for="PasswordTextBox" style="padding-top: 30px;">WACHTWOORD</label>
                            <input id="password" ref="password" name="password" tabindex="2" type="password" v-model="form['register'].password" />
                            <span class="validation-error">{{ errors[0] }}</span>
                        </validation-provider>

                        <span style="cursor: pointer; display: none;" @click.prevent="onPasswordForgetClick()" id="ForgetPasswordButton" class="button_small button_passwordforget" tabindex="3">Wachtwoord vergeten?</span>

                        <div v-if="!loading" class="buttons">
                            <span style="cursor: pointer;" @click="onRegisterClick(form.register)" id="RegisterButton" class="button button_register" tabindex="4">REGISTREER ></span>
                            <span style="cursor: pointer;" @click="onLoginClick(form.register)" id="LoginButton" class="button button_login" tabindex="5">LOGIN ></span>
                            <div class="remember-me-wrapper">
                                <label class="button">
                                    <input class="remember-me" v-model="rememberMe" type="checkbox" tabindex="6">Onthoud mij
                                </label>
                            </div>
                        </div>
                        <div v-else class="loader"></div>
                        
                        <input type="submit" 
                            style="position: absolute; left: -9999px; width: 1px; height: 1px;"
                            tabindex="-1" />

                        <div class="subtext-wrapper">
                            <span>*</span>
                            <span class="subtext">Jouw data wordt alleen hiervoor gebruikt en niet gedeeld met anderen.</span>
                        </div>
                    </form>
                    
                </div>
            </validation-observer>
        </div>
    </TopContainer>
</template>

<script>
    import Backend from '../services/Backend';
    import Auth from '../services/Auth';

    //components
    import TopContainer from './TopContainer.vue';

    import screenfull from 'screenfull';

    export default {
        components: {
            TopContainer
        },
        props: { },
        data()
        {
            return {
                'requestFailed': false,
                'loading': false,
                'error': null, 
                'message': null,
                'form': {
                    'register': {
                        email: '',
                        password: '',
                        // passwordConfirm: '',
                    }
                }
            }
        },
        methods: {
            onCancelClick() {
                this.$router.push({ name: 'login'});
            },
            onPasswordForgetClick() {
                this.$router.push({ name: 'password' });
            },
            onRegisterClick(form) {
                this.loading = true;
                this.requestFailed = false;

                if (mobileAndTabletCheck() && screenfull.isEnabled) {
                    try {
                        screenfull.request();
                    }
                    catch(e) {
                    }
                }

                this.$refs.formObserver.validate().then(success => {
                    if(!success) {
                        this.loading = false;
                        return;
                    }                         

                    Backend.register(form.email, form.password, 'seeker')
                        .done(() => {
                            Auth.login(form.email, form.password)
                                .done(() =>
                                {
                                    this.onAfterLogin();
                                })
                                .catch(() =>
                                {
                                    this.requestFailed = true;
                                    this.loading = false;
                                });
                        })
                        .catch((response) => {
                            this.loading = false;                            
                            if(response.status == 400 
                                && (response.responseJSON[0].code == 'DuplicateUserName' ||
                                    response.responseJSON[0].code == 'UserAlreadyInRole')) {
                                this.$refs.formObserver.setErrors({
                                    email: ['E-mailadres is al in gebruik']
                                });
                            } else {
                                this.requestFailed = true;
                                this.loading = false;
                            }
                        });
                })
                
            },
            onLoginClick(form) {
                this.loading = true;
                this.requestFailed = false;

                if (mobileAndTabletCheck() && screenfull.isEnabled) {
                    try {
                        screenfull.request();
                    }
                    catch(e) {
                    }
                }

                this.$refs.formObserver.validate().then(success => {
                    if(!success) {
                        this.loading = false;
                        return;
                    }

                    Auth.login(form.email, form.password)
                        .done(() =>
                        {
                            this.onAfterLogin();                            
                        })
                        .catch((response) =>
                        {
                            if(response.status == 400 
                                && response.responseJSON.error === 'invalid_grant') {
                                this.$refs.formObserver.setErrors({
                                    email: ['E-mailadres of wachtwoord is onbekend']
                                });
                            } else {
                                this.requestFailed = true;
                            }                            
                            this.loading = false;
                        });
                });
            },
            onAfterLogin() {

                this.loading = false;
                console.log('onafterlogin')

                if(this.rememberMe) {
                    console.log('set cookies');
                    this.$cookies.set("token", Auth.getRefreshToken());
                }
                
                this.$router.push({ name: 'loadassignment'});
            }
        }
    }
    
</script>
